<template>
  <div v-if="form">
    <component :is="formComponent" />
  </div>
</template>

<script>
import http from '@/plugin/axios'
import Form from '@utils/form'
import SoreTable from './score-table.vue'

function submit(data) {
  const { listFormula = [], list = [], dataList = [] } = data
  const value = list.map((item, index) => {
    const idx = index % listFormula.length
    const count = Math.floor(index / listFormula.length)
    const row = dataList[count] || {}
    const itemScore = row[`item${idx}`]
    return {
      ...item,
      itemScore
    }
  })
  return http({
    url: '/srmQualitativeScore/commentScore',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { id: this.$route.params.id, list: value }
  })
}

export default {
  data() {
    return {
      form: null
    }
  },
  computed: {
    formComponent() {
      return this.form ? this.form.end() : 'div'
    }
  },
  async created() {
    const data = await http({
      url: '/srmQualitativeScore/getSrmQualitativeScoreById',
      baseURL: process.env.VUE_APP_PURCHASE_API,
      data: { id: this.$route.params.id }
    })

    const list = data.list || []
    const listFormula = data.listFormula || []
    const value = []
    list.forEach((item, index) => {
      const idx = index % listFormula.length
      let val
      if (idx) {
        val = value[value.length - 1]
      } else {
        val = { supOfficeName: item.supOfficeName }
        value.push(val)
      }
      val[`item${idx}`] = item.itemScore
    })

    data.dataList = value
    const form = new Form('performance.qualitativescore')
      .dataUrl((vm) => {
        vm.setData(data)
        vm.createForm()
      })
      .url(submit)
      .title('formTitle.baseInfo')
      .add('formulaName').disabled()
      .add('purOfficeName').disabled()
      .add('performanceDate').disabled()
      .addGroup()
      .formItemComponent(['list', 'listFormula', 'dataList'], SoreTable, [[], []]).mapKey('table')

    const gradeFlag = list[0] && list[0].gradeFlag
    const btns = [
      { type: 'primary', event: 'submit', text: 'common.submit', show() { return gradeFlag } },
      { type: 'default', text: 'common.cancel', handle() { this.$router.back() } }
    ]
    form.btns(btns)
    form.bind('form', form)

    this.form = form
  }
}
</script>
